import { WireAdapter } from "lwc";

import { MEDIA_QUERIES } from "common/mediaQueryAdapter";
import { attrToBool } from "common/helpers";

export type AnimationAdapterConfig = {
  enabled?: boolean | string | null;
};

export type AnimationAdapterValue = {
  enabled: boolean;
};

let globalEnabled = true;
let adapters = new Set<AnimationAdapter>();

export function setEnabled(enabled: boolean) {
  globalEnabled = enabled;
  for (let adapter of adapters) {
    adapter.setValue(adapter.value);
  }
}

export class AnimationAdapter implements WireAdapter {
  mediaQuery: MediaQueryList = window.matchMedia(MEDIA_QUERIES.reducedMotion);

  private config: AnimationAdapterConfig & { enabled?: boolean } = {
    enabled: true,
  };

  setValue: (value: AnimationAdapterValue) => void;

  private get enabled(): boolean {
    if (this.mediaQuery.matches) {
      return false;
    }
    if (globalEnabled === false) {
      return false;
    }
    return this.config.enabled ?? true;
  }

  get value(): AnimationAdapterValue {
    return {
      enabled: this.enabled,
    };
  }

  constructor(setValue: (value: AnimationAdapterValue) => void) {
    this.setValue = setValue;
    adapters.add(this);
  }

  private onChange = () => {
    this.setValue(this.value);
  };

  connect() {
    this.setValue(this.value);
    this.mediaQuery.addEventListener("change", this.onChange);
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.onChange);
    adapters.delete(this);
  }

  update(config: AnimationAdapterConfig) {
    this.config = {
      ...config,
      enabled:
        typeof config.enabled !== "undefined"
          ? attrToBool(config.enabled)
          : undefined,
    };
    this.setValue(this.value);
  }
}
